import type { GetTweets200PageAllOfThreeContentItemEngagementAllOf } from './getTweets200PageAllOfThreeContentItemEngagementAllOf';
import type { GetTweets200PageAllOfThreeContentItemEngagementAllOfTwo } from './getTweets200PageAllOfThreeContentItemEngagementAllOfTwo';

export type GetTweets200PageAllOfThreeContentItemEngagement = GetTweets200PageAllOfThreeContentItemEngagementAllOf & GetTweets200PageAllOfThreeContentItemEngagementAllOfTwo;
